import { mapState, mapGetters, mapActions } from 'vuex'

export const deviceListComputed = {
  ...mapState('deviceList', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('deviceList', ['getDeviceList', 'getRegisterErrors']),
}

export const deviceListMethods = mapActions('deviceList', [
  'fetchingDeviceList',
  'resetDeviceList',
  'deleteDeviceById',
  'editDeviceById',
  'registerDevice',
])
